import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../../../index";
import { api, rawApi } from "../../../../lib";
import { GetStockSkusRequest, StockSkuResource } from "../../../../models/api/barcodeSystem/stockSkus/get";
import { ImportStockSkusRequest, ImportStockSkusResponse } from "../../../../models/api/barcodeSystem/stockSkus/importStockSkus";

const name = "stockSku";

if (Store.state[name]) {
  Store.unregisterModule(name);
}

@Module({ name: name, dynamic: true, store: Store, namespaced: true, stateFactory: true })
export default class StockSkuModule extends VuexModule {
  public loading: boolean = false;
  public error: boolean = false;
  public errorMessage: string = "";
  public stockSkus: StockSkuResource[] = null;

  @Action
  async createStockSku(payload) {
    return await api.postAsync("/barcode/stockSkus", payload);
  }

  @Action
  async updateStockSku(payload) {
    return await api.putAsync(`/barcode/stockSkus/${payload.id}`, payload);
  }

  @Action
  async deleteStockSku(id: number) {
    return await api.deleteAsync(`/barcode/stockSkus/${id}`);
  }

  @Action
  async getStockSkus(request: GetStockSkusRequest) {
    let target = "/barcode/stockSkus?";

    if (request.companyId)
      target += `companyId=${request.companyId}&`;
    if (request.manufacturerCode)
      target += `manufacturerCode=${encodeURIComponent(request.manufacturerCode)}&`;

    return await api.getAsync(target);
  }

  @Action
  async getStockSku(id: number) {
    const response = await api.getAsync(`/barcode/stockSkus/${id}`);
    return response.data;
  }

  @Action
  async loadStockSkus(request: GetStockSkusRequest): Promise<void> {
    const response = await this.getStockSkus(request);
    this.setStockSkus(response.data);
  }

  @Mutation
  setStockSkus(stockSkus: StockSkuResource[]) {
    this.stockSkus = stockSkus;
  }

  @Action
  async importStockSkus(request: ImportStockSkusRequest): Promise<ImportStockSkusResponse> {
    const formData = new FormData();
    formData.append("file", request.file);

    const response = await rawApi.post<ImportStockSkusResponse>(
      `/barcode/stockSkus/import?companyId=${request.companyId}&manufacturerCode=${encodeURIComponent(request.manufacturerCode)}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    return response.data;
  }
}
